import React from 'react';
import PropTypes from 'prop-types';

/**
 * AnnuityPlanSection Component
 * Annuity-specific fields for the Plan column (Quote Value and Premium)
 */
const AnnuityPlanSection = ({ formData, onInputChange, styles }) => {
  return (
    <div style={styles.formGrid}>
      {/* Quote Value at End of Year */}
      <div style={styles.formGroup} data-itemid='annuity-quote-value-wrapper'>
        <label style={styles.label} data-itemid='annuity-quote-value-label'>
          Quote Value at End of Year
        </label>
        <select data-itemid='annuity-quote-value-select' onChange={e => onInputChange('quoteValue', e.target.value)} style={styles.select} value={formData.quoteValue || '5'}>
          {Array.from({ length: 10 }, (_, i) => (
            <option key={i + 1} value={i + 1} data-itemid={`annuity-quote-value-option-year-${i + 1}`}>
              Year {i + 1}
            </option>
          ))}
        </select>
      </div>

      {/* Premium Amount */}
      <div style={styles.formGroup} data-itemid='annuity-premium-amount-wrapper'>
        <div style={styles.row} data-itemid='annuity-premium-amount-label-wrapper'>
          <label style={styles.label} data-itemid='annuity-premium-amount-label'>
            Premium Amount
          </label>
          <label style={{ ...styles.label, color: 'red' }} data-itemid='annuity-premium-amount-label-required'>
            *
          </label>
        </div>
        <input
          data-itemid='annuity-premium-amount-input'
          onBlur={e => {
            if (formData.premiumAnnuity) {
              e.target.value = `$${parseInt(formData.premiumAnnuity).toLocaleString()}`;
            }
          }}
          onChange={e => {
            const numericValue = e.target.value.replace(/[^0-9]/g, '');
            onInputChange('premiumAnnuity', numericValue);
          }}
          onFocus={e => {
            if (formData.premiumAnnuity) {
              e.target.value = formData.premiumAnnuity;
            }
          }}
          placeholder='Enter premium amount...'
          style={styles.input}
          type='text'
          value={formData.premiumAnnuity ? `$${parseInt(formData.premiumAnnuity).toLocaleString()}` : ''}
        />
      </div>
    </div>
  );
};

AnnuityPlanSection.propTypes = {
  formData: PropTypes.object.isRequired,
  onInputChange: PropTypes.func.isRequired,
  styles: PropTypes.object.isRequired
};

export default AnnuityPlanSection;
